import React from 'react';
import PropTypes from 'prop-types';
import CircularProgress from 'material-ui/CircularProgress';
import './refreshIndicatorLoading.scss';

const rootStyle = {
  display: 'inline-block',
  position: 'relative'
};

// The father of this component, should be position: relative
const RefreshIndicatorLoading = props => {
  const { style, size } = props;
  const newStyle = Object.assign(rootStyle, style);
  return (
    <div className="refreshIndicatorLoading__style">
      <CircularProgress
        size={ size }
        thickness={ 5 }
        left={ 0 }
        top={ 0 }
        status="loading"
        style={ newStyle }
      />
    </div>
  );
};

RefreshIndicatorLoading.propTypes = {
  style: PropTypes.object,
  size: PropTypes.number
};

RefreshIndicatorLoading.defaultProps = {
  style: {},
  size: 100
};

export default RefreshIndicatorLoading;



// WEBPACK FOOTER //
// ./src/shared/components/refreshIndicatorLoading/RefreshIndicatorLoading.js